import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "#1E1E1E",
      d: "M3.429.5H28.57A2.929 2.929 0 0 1 31.5 3.429V28.57a2.929 2.929 0 0 1-2.929 2.929H3.43A2.929 2.929 0 0 1 .5 28.571V3.43A2.929 2.929 0 0 1 3.429.5Zm23.694 12.374c-.99.766-2.368 1.793-6.794 5.005-.531.388-1.153.922-1.925 1.392-.76.464-1.576.804-2.402.8h-.005c-.82.004-1.629-.33-2.385-.79-.767-.466-1.392-1.002-1.938-1.4l-.001-.001-2.791-2.03c-2.302-1.68-3.262-2.402-4.005-2.976l-.806-.623v11.178c0 1.223.992 2.214 2.215 2.214h19.428a2.215 2.215 0 0 0 2.215-2.214V12.25l-.806.623ZM6.286 6.357a2.215 2.215 0 0 0-2.215 2.214v2.042l.194.15c1.307 1.018 1.6 1.282 4.4 3.335l3.764 2.743c.332.242.948.748 1.548 1.147.311.207.645.404.98.55.323.142.68.248 1.035.246v.001h.016-.001c.355.002.712-.105 1.037-.247.334-.146.668-.343.979-.55.6-.399 1.217-.906 1.548-1.147 6.482-4.704 6.42-4.72 8.164-6.077l.194-.15V8.57a2.215 2.215 0 0 0-2.215-2.214H6.286Z"
    }, null, -1)
  ])))
}
export default { render: render }